import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ContactsHttpService {
    private readonly apiUrl = environment.apiUrl;

    constructor(private readonly httpClient: HttpClient) { }

    sendMessage(payload: {
        name: string;
        email: string;
        phone: string;
        message: string;
    }): Observable<any> {
        return this.httpClient.post(`${this.apiUrl}/contacts/message`, payload);
    }

    requestPhoneCall(payload: {
        name: string;
        company_name: string;
        email: string;
        phone: string;
        convenient_time: string;
        message: string;
    }): Observable<any> {
        return this.httpClient.post(`${this.apiUrl}/contacts/phone`, payload);
    }
}
